<div>
  @if (!whiteLabelInfo) {
    Powered By: <img width="50" src="../../../assets/rexpay/ga.png" />
    <p class="help">
      Need help?
      <a
        href="https://www.myrexpay.ng/"
        target="_blank"
        class="text-primary mail"
        >Contact Us</a
        >
      </p>
    }
    @if (whiteLabelInfo) {
      Powered By:
      @if (whiteLabelInfo) {
        <img
          width="50"
          [src]="whiteLabelInfo.logoUrl"
          alt="logo"
          class="logo"
          />
      }
    }
  </div>
